import React, { useState } from "react";
import { url } from "../settings";

// Dependencies

//Components

// Styles
import styled from "styled-components";
import { fontFamily } from "../Typography";
import { grayscale, blue } from "../Utilities";
import { fontWeight } from "../Cytoplasm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive as faArchiveDuo } from "@fortawesome/pro-duotone-svg-icons";
import { faArchive as faArchiveSolid } from "@fortawesome/pro-regular-svg-icons";

export default function ArchiveTutorial(props) {
  const { user, dismissed, setArchiveTutorial } = props;

  function dismissNotification() {
    setArchiveTutorial(true);
    setVisible(false);
    return fetch(`${url}/rounds/dismiss-notification/`, {
      method: "post",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        userId: user.id,
        notification: "archive_tutorial",
      }),
    }).then((response) => {
      return response;
    });
  }

  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  if (dismissed) return null;

  return (
    <TutorialContainer>
      <FontAwesomeIcon icon={faArchiveDuo} size="6x" />
      <div className="text">ARCHIVE</div>
      <div className="big-text">Save Your Favorite Encounters</div>
      <div className="text">
        You can save your favorite encounters by clicking the{" "}
        <strong>Archive</strong> (<FontAwesomeIcon icon={faArchiveSolid} />)
        icon during an encounter. This will save the encounter to your archive
        so you can find it easier later on.
      </div>
      <div className="confirm" onClick={() => dismissNotification()}>
        Dismiss
      </div>
    </TutorialContainer>
  );
}
const TutorialContainer = styled.div`
  padding: 25px;
  margin-top: 35px;
  background-color: ${grayscale.lightGray};
  text-align: center;
  .text {
    font-size: 18px;
    max-width: 500px;
    margin: auto;
    margin-top: 15px;
  }
  .big-text {
    font-size: 28px;
    font-weight: 700;
    margin-top: 20px;
  }
  .confirm {
    padding: 8px 10px;
    border-radius: 5px;
    background-color: ${grayscale.gray};
    color: ${blue.bright};
    max-width: fit-content;
    margin: auto;
    margin-top: 25px;
    cursor: pointer;
    font-weight: ${fontWeight.bold};
    &:hover {
      background-color: ${grayscale.gray};
    }
  }
`;
